module.exports = __webpack_public_path__ + "static/media/ios-image.c2d00837.svg";